import React from 'react';

export const CategoryFileArchiveContext = React.createContext({});
